import { Cookie } from "../Cookie/Cookie.js";
var cookie = new Cookie();
window.cookie = cookie;

import { Ajax } from "../Ajax/Ajax.js";
var ajax = new Ajax();
window.ajax = ajax;

import { VForm } from "./VForm.js";
var vform = new VForm();
window.vform = vform;
vform.applyEvents();

import { Config } from "../Config/Config.js";
var config = new Config();
window.config = config;

import { Hotel } from "../Hotel/Hotel.js";
var hotel = new Hotel();
window.hotel = hotel;
hotel.applyEvents();

import { Tour } from "../Excursions/Tour.js";
var tour = new Tour();
window.tour = tour;
tour.applyEvents();

import { Rest } from "../Restaurants/Rest.js";
var rest = new Rest();
window.rest = rest;

import { Order } from "../Order/Order.js";
var order = new Order();
window.order = order;

import { Auth } from "../Auth/Auth.js";
var auth = new Auth();
window.auth = auth;

import { Visa } from "../Visa/Visa.js";
var visa = new Visa();
window.visa = visa;
visa.applyEvents();

import { Service } from "../Service/Service.js";
var service = new Service();
window.service = service;

/*import { XMLState } from "../_VROC/XMLState.js";
var state = new XMLState();
window.state = state;*/

/*
import { VROC } from "../_VROC/VROC.js";
var vroc = new VROC();
window.vroc = vroc;


if (location.pathname == '/crm/')
{
	vroc.loadComponent({
	  id: 'hotels',
	  xmlUrl: '/ajax.php?mid=3&action=loadXML',
	  templateId: 'mod_crm/accoms',
	  container: $('main')[0]
	});

}
*/

import { VROC } from '../_VROC/VROC.js';
const vroc = new VROC();
window.vroc = vroc;

import { CRM } from "../CRM/crm.js";
var crm = new CRM();
window.crm = crm;
crm.applyEvents();


import { CRMOrders } from '../CRM/Orders/Orders.js';
//import { CRMInterface } from '../CRM/Orders/Interface.js';

const crmOrders = new CRMOrders(vroc);
window.crmOrders = crmOrders;





import { MICE } from "../MICE/mice.js";
var mice = new MICE();
window.mice = mice;

// import { CRM } from "../CRM/CRM.js";
// var crm = new CRM();
// window.crm = crm;

// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

if (isTouchDevice()) {
	$("body").removeClass("des");
	$("body").addClass("mob");
} else {
	$("body").removeClass("mob");
	$("body").addClass("des");
}

document.documentElement.classList.add('no-smooth');

window.addEventListener('load', () => {
	// Дождаться завершения загрузки страницы и убрать класс
	setTimeout(() => {
		document.documentElement.classList.remove('no-smooth');
	}, 0);
});

const doc = document.documentElement
const appSizes = () => {
	let windowHeight = $(window).height();
	doc.style.setProperty('--app-height', windowHeight + "px");

	let headerHeight = $('.header').outerHeight();
	doc.style.setProperty('--header-height', headerHeight + "px");

	let mainNavHeight = $('.main-nav').outerHeight();
	doc.style.setProperty('--main-nav-height', mainNavHeight + "px");

	if ($('.order-table').length > 0 && $('.order-table__service').length > 0) {
		let orderTableServiceWidth = $('.order-table__service').eq(0).outerWidth();
		doc.style.setProperty('--order-table-service-width', orderTableServiceWidth + "px");
		let orderTableServiceLeft = $('.order-table__service').eq(0).offset().left - $(".order__table-wrapper").offset().left;
		doc.style.setProperty('--order-table-service-left', orderTableServiceLeft + "px");
	}
}
appSizes();


// Main nav
$(".header__burger").on("click", function () {
	$("body").toggleClass("no-scroll");
	$(this).toggleClass("active");
	$(".main-nav").toggleClass("active");

	if ($(".section-nav").hasClass("active")) {
		$(".section-nav").removeClass("active");
	}
	if ($(".main-nav__btn").hasClass("active")) {
		$(".main-nav__btn").removeClass("active");
	}
});

if (!window.matchMedia("(min-width: 1024px)").matches) {
	$(".main-nav").on("click", function (e) {
		var callbackPopup = $(".main-nav__conatiner");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__burger").removeClass("active");
			$(".main-nav").removeClass("active");
			$("body").removeClass("no-scroll");
		};
	});
}


// Section nav
$(".main-nav__btn").on("click", function () {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(this).hasClass("active")) {
			$("body").removeClass("no-scroll");
			$(".main-nav").removeClass("section-nav-open");
		} else {
			$("body").addClass("no-scroll");
			$(".main-nav").addClass("section-nav-open");
		}
	}

	let dataSectionNavName = $(this).attr("data-section-nav-open");
	let sectionNav = $(".section-nav[data-section-nav-name=" + dataSectionNavName + "]");

	$(".main-nav__btn").not($(this)).removeClass("active");
	$(".section-nav").not(".section-nav[data-section-nav-name=" + dataSectionNavName + "]").removeClass("active");

	$(this).toggleClass("active");
	sectionNav.toggleClass("active");
});

$(".section-nav__back").on("click", function () {
	$(this).closest(".section-nav").removeClass("active");
	if ($(".main-nav__btn").hasClass("active")) {
		$(".main-nav__btn").removeClass("active");
	}
});


$(".section-nav").on("click", function (e) {
	var callbackPopup = $(".section-nav__wrapper");
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(".section-nav").removeClass("active");
		$(".main-nav__btn").removeClass("active");
		$(".main-nav").removeClass("section-nav-open");
		if (window.matchMedia("(min-width: 1024px)").matches) {
			$("body").removeClass("no-scroll");
		}
	};
});


// Resize
$(window).on("resize", function () {
	// is touch
	isTouchDevice();

	// app heights
	appSizes();

	// Main nav
	if ($(".main-nav").hasClass("active") && window.matchMedia("(min-width: 1024px)").matches) {
		$(".header__burger").removeClass("active");
		$(".main-nav").removeClass("active");
		if (!$(".section-nav").hasClass("active")) {
			$("body").removeClass("no-scroll");
		}
	}

	// Section nav
	if ($(".section-nav").hasClass("active")) {
		$(".section-nav").removeClass("active");
		$(".main-nav__btn").removeClass("active");
		$(".main-nav").removeClass("section-nav-open");
		if (window.matchMedia("(min-width: 1024px)").matches) {
			$("body").removeClass("no-scroll");
		}
	}

	if (visaFormFileLabels.length > 0) {
		setvisaFormFileLabelsMinHeights();
	}
});


// Scroll
let lastScrollTop = 0;
const excursionFinal = document.querySelector(".excursion__final");
$(window).on("scroll", function () {
	// app heights
	appSizes();

	if (window.matchMedia("(min-width: 1024px)").matches) {
		let st = $(this).scrollTop();
		if (st > 0 || st > 0 && st <= $('.header').outerHeight()) {
			$(".main-nav").addClass("hidden");
			if (st < lastScrollTop) {
				$(".main-nav").removeClass("hidden");
			}
		}
		else {
			$(".main-nav").removeClass("hidden");
		}
		lastScrollTop = st;
	}

	// if (window.matchMedia("(max-width: 767px)").matches && excursionFinal) {
	if (excursionFinal) {
		let excursionFinalRect = excursionFinal.getBoundingClientRect();
		if (excursionFinalRect.top <= $(window).height()) {
			$(".excursion__to-final").addClass("hidden");
		} else {
			$(".excursion__to-final").removeClass("hidden");
		}
	}
})


// Document click
$(document).on("click", function (e) {
	// Main nav
	if ($(".main-nav").hasClass("active") && !window.matchMedia("(min-width: 1024px)").matches) {
		var callbackPopup = $(".header__burger, .main-nav, .section-nav");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__burger").removeClass("active");
			$(".main-nav").removeClass("active");
			$("body").removeClass("no-scroll");
		};
	}


	if ($(".section-nav").hasClass("active")) {
		var callbackPopup = $(".header__burger, .section-nav, .main-nav__btn");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".main-nav__btn").removeClass("active");
			$(".section-nav").removeClass("active");
			$(".main-nav").removeClass("section-nav-open");
			if (window.matchMedia("(min-width: 1024px)").matches) {
				$("body").removeClass("no-scroll");
			}
		};
	}

	// Hotels form
	if ($(".settings-date__button").hasClass("active")) {
		var callbackPopup = $(".settings-date__button, .settings-date__calendar");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".settings-date__button").removeClass("active");
			$(".settings-date__calendar").removeClass("active");
			config.closeCalendar();
		};
	}

	if ($(".settings-people__button").hasClass("active")) {
		var callbackPopup = $(".settings-people__button, .settings-people__popup");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".settings-people__button").removeClass("active");
			$(".settings-people__popup").removeClass("active");
		};
	}

	// form multi
	if ($(".form-multi__choice").hasClass("active")) {
		var callbackPopup = $(".form-multi__top-input, .form-multi__result, .form-multi__choice");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".form-multi__top-input").removeClass("active");
			$(".form-multi__choice").removeClass("active");
		};
	}

	// Order share
	if ($(".order-table__share-list").hasClass("active")) {
		var callbackPopup = $(".order-table__share-toggler, .order-table__share-list");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".order-table__share-list").removeClass("active");
		};
	}

	// Mice contacts
	if ($(".contacts-element__list").hasClass("active")) {
		var callbackPopup = $(".contacts-element__toggler, .contacts-element__list");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".contacts-element__list").removeClass("active");
		};
	}

	// Order table status
	if ($(".order-table__status-tooltip").hasClass("active")) {
		var callbackPopup = $(".order-table__status-point");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".order-table__status-tooltip").removeClass("active");
		};
	}
});


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");

	// popup YT
	if ($(this).closest(".popup").hasClass("popup-yt")) {
		$(".popup-yt__iframe").attr("src", "");
	}
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");

		// popup YT
		if ($(this).hasClass("popup-yt")) {
			$(".popup-yt__iframe").attr("src", "");
		}
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let dataPopupClose = $(this).attr("data-popup-close");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");

	if (dataPopupClose === "true") {
		$(this).closest(".popup").removeClass("active");
		popup.addClass("active");
	} else {
		$("body").addClass("no-scroll");
		popup.addClass("active");
	}

	// popup YT
	if (dataPopupName === "popup-yt") {
		$(".popup-yt__iframe").attr("src", $(this).attr("href"));
	}

	if (dataPopupName === "popup-service-delete") {
		let tr = $(this).closest('tr');
		let id = tr.attr('data-id');
		let name = tr.find('.order-table__service .font-weight-500').text();

		popup.find("input[name=id]").val(id);
		popup.find("input[name=service_name]").val(name);
	}

	if (dataPopupName === "popup-hotel-request") {
		let tr = $(this).closest('tr');
		let id = tr.attr('data-id');

		popup.find('.form__main').show();
		popup.find('.form__success').hide();

		popup.find("input[type=hidden][name=id]").val(id);
	}
});

document.addEventListener("keypress", function onEvent(e) {
	if (e.key === "Escape") {
		if ($(".popup").hasClass("active")) {
			e.preventDefault();

			// popup YT
			if ($(".popup-yt").hasClass("active")) {
				$(".popup-yt__iframe").attr("src", "");
			}

			$(".popup").removeClass("active");
			$("body").removeClass("no-scroll");
		}
	}
});


// tabs
$(".tabs").each(function () {
	$(this).find(".tabs__tab:not(:eq(0))").hide();
	$(this).find(".tabs__nav-btn:eq(0)").addClass("active");
});

$(".tabs__nav-btn").on("click", function () {
	if (!$(this).hasClass("active")) {
		$(this).closest(".tabs").find(".tabs__nav-btn").removeClass("active");
		$(this).closest(".tabs").find(".tabs__tab").hide();
		$(this).addClass("active");
		$(this).closest(".tabs").find(".tabs__tab").eq($(this).index(".tabs__nav-btn")).fadeIn();
	}
});


// Hotels form
$(".settings-search__input, .settings-search__item-input").on("focus", function () {
	$(this).closest(".settings-search__main").siblings(".settings-search__popup").addClass("active");
});

$(".settings-search__input, .settings-search__item-input").on("blur", function () {
	$(this).closest(".settings-search__main").siblings(".settings-search__popup").removeClass("active");
});

$(".settings-date__button").on("click", function () {
	if ($(this).hasClass("active")) {
		config.closeCalendar();
	}
	else {
		config.openCalendar();
	}
	$(this).toggleClass("active");
	$(this).siblings(".settings-date__calendar").toggleClass("active");
});

$(".settings-people__button").on("click", function () {
	$(this).toggleClass("active");
	$(this).siblings(".settings-people__popup").toggleClass("active");
});

$(".additional-form__filters-toggler").on("click", function () {
	$("body").addClass("no-scroll");
	$(".filters").addClass("active");
});

$(".filters__close").on("click", function () {
	$("body").removeClass("no-scroll");
	$(".filters").removeClass("active");
});

$('.popup-car').each(function () {
	let popupCarThumbs = new Swiper($(this).find(".popup-car-thumbs")[0], {
		spaceBetween: 8,
		slidesPerView: 5,
		watchSlidesProgress: true,
	});
	let popupCarSlider = new Swiper($(this).find(".popup-car-slider")[0], {
		modules: [Thumbs, EffectFade],
		spaceBetween: 8,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		thumbs: {
			swiper: popupCarThumbs,
			autoScrollOffset: 1,
		},
	});
});

const hotelClub = document.querySelector('.hotel-club')
if (hotelClub) {
	let hotelClubThumbs = new Swiper(".hotel-club-thumbs", {
		spaceBetween: 8,
		slidesPerView: 5,
		watchSlidesProgress: true,
	});
	let hotelClubSlider = new Swiper(".hotel-club-slider", {
		modules: [Thumbs, EffectFade],
		spaceBetween: 8,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		thumbs: {
			swiper: hotelClubThumbs,
			autoScrollOffset: 1,
		},
	});
};


$(".order-table__actions-check").on("click", function () {
	$(this).toggleClass("active");
	if ($(this).hasClass("active")) {
		$(this).closest(".order-table__tr").attr('disabled', true);
		$(this).closest(".order-table__tr").find('input').prop('disabled', true);
	} else {
		$(this).closest(".order-table__tr").attr('disabled', false);
		$(this).closest(".order-table__tr").find('input').prop('disabled', false);
	}
});

$(".order-overprice__item-input").on("change", function () {
	if ($(".order-overprice__item-input--hand").is(":checked")) {
		$(".order-overprice__hand").slideDown();
	} else {
		$(".order-overprice__hand").slideUp();
	}
});



const visaFormFileLabels = document.querySelectorAll(".visa-form__file-label");
const setvisaFormFileLabelsMinHeights = function () {
	let maxHeight = Math.max.apply(null, $(".visa-form__file-label").map(function () {
		return $(this).height();
	}).get());
	for (let index = 0; index < visaFormFileLabels.length; index++) {
		const element = visaFormFileLabels[index];
		element.style.minHeight = maxHeight + "px";
	}
}

if (visaFormFileLabels.length > 0) {
	setvisaFormFileLabelsMinHeights();
}


// form time
// document.addEventListener('DOMContentLoaded', () => {
// 	const timeForms = document.querySelectorAll('.form__time.form-time');

// 	timeForms.forEach(form => {
// 		const hourInput = form.querySelector('.form-time__input--hour');
// 		const minutesInput = form.querySelector('.form-time__input--min');
// 		const popup = form.querySelector('.form-time__popup');
// 		const hourButtons = popup.querySelectorAll('.form-time__choice-btn--hour');
// 		const minuteButtons = popup.querySelectorAll('.form-time__choice-btn--min');

// 		let isClickingHourButton = false; // Флаг для отслеживания клика по кнопкам часов

// 		// Функция для показа попапа
// 		function showPopup() {
// 			popup.classList.add('active');
// 		}

// 		// Функция для скрытия попапа
// 		function hidePopup() {
// 			popup.classList.remove('active');
// 		}

// 		// Функция для корректировки введенных значений
// 		function correctValue(input, max) {
// 			let value = parseInt(input.value, 10);
// 			if (isNaN(value)) {
// 				value = 0;
// 			}
// 			value = Math.min(Math.max(value, 0), max);  // Ограничиваем значение
// 			input.value = value.toString().padStart(2, '0');  // Преобразуем в двузначное число
// 		}

// 		// Ограничение ввода: только цифры и максимум 2 символа
// 		function restrictInput(input, max) {
// 			input.addEventListener('input', () => {
// 				input.value = input.value.replace(/\D/g, '').slice(0, 2);
// 				if (input.value.length === 2) {
// 					correctValue(input, max);
// 					if (input === hourInput) {
// 						minutesInput.focus();
// 						showPopup();
// 					}
// 					if (input === minutesInput && hourInput.value.length === 2) {
// 						hidePopup();  // Закрываем попап, если обе строки заполнены вручную
// 						minutesInput.blur();
// 					}
// 				}
// 			});

// 			input.addEventListener('blur', () => {
// 				correctValue(input, max);  // Преобразуем значение в двузначное при потере фокуса
// 				setTimeout(() => {
// 					// Попап должен быть скрыт, если ни одно из полей не в фокусе
// 					if (!isClickingHourButton && !hourInput.matches(':focus') && !minutesInput.matches(':focus')) {
// 						hidePopup();
// 					}
// 				}, 200);
// 			});
// 		}

// 		restrictInput(hourInput, 23);
// 		restrictInput(minutesInput, 59);

// 		// Показ попапа при фокусе на инпутах
// 		hourInput.addEventListener('focus', () => {
// 			setTimeout(() => {
// 				hourInput.select();  // Выделяем всё содержимое
// 			}, 0);
// 			showPopup();
// 		});

// 		minutesInput.addEventListener('focus', () => {
// 			setTimeout(() => {
// 				minutesInput.select();  // Выделяем всё содержимое
// 			}, 0);
// 			showPopup();
// 		});

// 		// Обработка кликов по кнопкам часов
// 		hourButtons.forEach(button => {
// 			button.addEventListener('mousedown', () => {
// 				isClickingHourButton = true;  // Устанавливаем флаг при клике на кнопку часов
// 			});

// 			button.addEventListener('click', () => {
// 				hourInput.value = button.textContent.trim().padStart(2, '0');
// 				minutesInput.focus(); // Переключаем фокус на минуты после выбора часов
// 				showPopup(); // Оставляем попап открытым
// 				isClickingHourButton = false;  // Сбрасываем флаг после обработки клика
// 			});
// 		});

// 		// Обработка кликов по кнопкам минут
// 		minuteButtons.forEach(button => {
// 			button.addEventListener('click', () => {
// 				minutesInput.value = button.textContent.trim().padStart(2, '0');
// 				if (hourInput.value.length === 0) { // Если часы не заполнены, переносим фокус на часы
// 					hourInput.focus();
// 				} else { // Если часы заполнены, скрываем попап
// 					hidePopup();
// 					minutesInput.blur(); // Убираем фокус с минут
// 				}
// 			});
// 		});

// 		// Сброс флага при клике вне кнопок часов
// 		document.addEventListener('click', () => {
// 			isClickingHourButton = false;
// 		});
// 	});
// });

document.addEventListener('DOMContentLoaded', () => {
	const timeForms = document.querySelectorAll('.form__time.form-time');

	timeForms.forEach(form => {
		const hourInput = form.querySelector('.form-time__input--hour');
		const minutesInput = form.querySelector('.form-time__input--min');
		const popup = form.querySelector('.form-time__popup');
		const hourButtons = popup.querySelectorAll('.form-time__choice-btn--hour');
		const minuteButtons = popup.querySelectorAll('.form-time__choice-btn--min');

		let isClickingHourButton = false; // Флаг для отслеживания клика по кнопкам часов

		// Функция для показа попапа
		function showPopup() {
			popup.classList.add('active');
			const timeSelector = popup.querySelector('.form-time__choice-list');
			const targetElement = timeSelector.children[12]; // Получаем 12-й элемент
			if (targetElement) {
				timeSelector.scrollTop = targetElement.offsetTop; // Скроллим к нему
			}
		}

		// Функция для скрытия попапа
		function hidePopup() {
			popup.classList.remove('active');
		}

		// Функция для корректировки введенных значений, исключая пустые
		function correctValue(input, max) {
			if (input.value === "") return;  // Если поле пустое, ничего не делаем
			let value = parseInt(input.value, 10);
			if (isNaN(value)) {
				value = 0;
			}
			value = Math.min(Math.max(value, 0), max);  // Ограничиваем значение
			input.value = value.toString().padStart(2, '0');  // Преобразуем в двузначное число
		}

		// Ограничение ввода: только цифры и максимум 2 символа
		function restrictInput(input, max) {
			input.addEventListener('input', () => {
				input.value = input.value.replace(/\D/g, '').slice(0, 2);
				if (input.value.length === 2) {
					correctValue(input, max);
					if (input === hourInput) {
						minutesInput.focus();
						showPopup();
					}
					if (input === minutesInput && hourInput.value.length === 2) {
						hidePopup();  // Закрываем попап, если обе строки заполнены вручную
						minutesInput.blur();
					}
				}
			});

			input.addEventListener('blur', () => {
				correctValue(input, max);  // Преобразуем значение в двузначное при потере фокуса
				setTimeout(() => {
					// Попап должен быть скрыт, если ни одно из полей не в фокусе
					if (!isClickingHourButton && !hourInput.matches(':focus') && !minutesInput.matches(':focus')) {
						hidePopup();
					}
				}, 200);
			});
		}

		restrictInput(hourInput, 23);
		restrictInput(minutesInput, 59);

		// Показ попапа при фокусе на инпутах
		hourInput.addEventListener('focus', () => {
			setTimeout(() => {
				hourInput.select();  // Выделяем всё содержимое
			}, 0);
			showPopup();
		});

		minutesInput.addEventListener('focus', () => {
			setTimeout(() => {
				minutesInput.select();  // Выделяем всё содержимое
			}, 0);
			showPopup();
		});

		// Обработка кликов по кнопкам часов
		hourButtons.forEach(button => {
			button.addEventListener('mousedown', () => {
				isClickingHourButton = true;  // Устанавливаем флаг при клике на кнопку часов
			});

			button.addEventListener('click', () => {
				hourInput.value = button.textContent.trim().padStart(2, '0');
				$(hourInput).trigger('change');
				minutesInput.focus(); // Переключаем фокус на минуты после выбора часов
				showPopup(); // Оставляем попап открытым
				isClickingHourButton = false;  // Сбрасываем флаг после обработки клика
			});
		});

		// Обработка кликов по кнопкам минут
		minuteButtons.forEach(button => {
			button.addEventListener('click', () => {
				minutesInput.value = button.textContent.trim().padStart(2, '0');
				$(minutesInput).trigger('change');
				if (hourInput.value.length === 0) { // Если часы не заполнены, переносим фокус на часы
					hourInput.focus();
				} else { // Если часы заполнены, скрываем попап
					hidePopup();
					minutesInput.blur(); // Убираем фокус с минут
				}
			});
		});

		// Сброс флага при клике вне кнопок часов
		document.addEventListener('click', () => {
			isClickingHourButton = false;
		});
	});

	// document.querySelector('.transfers-form').addEventListener("keydown", (event) => {
	// 	if (event.key === "Enter" && event.target.tagName === "INPUT") {
	//         const activeElement = event.target;

	//         // Проверяем, является ли активный элемент полем ввода (input)
	//         if (activeElement.tagName === "INPUT") {
	//             // Выполняем `blur` (убираем фокус с поля)
	//             activeElement.blur();
	//             $(activeElement).closest('.form-multi__choice').removeClass('active');
	//             $(activeElement).closest('.form-multi__top').find('input').removeClass('active');

	//             // Предотвращаем стандартное поведение, связанное с отправкой формы
	//             event.preventDefault();
	//         }
	//     }
	// });
});


// FACTS
$(".visa-get__facts-item-toggler").on("click", function () {
	$(".visa-get__facts-item-toggler").not(this).removeClass("active");
	$(".visa-get__facts-item-toggler").not(this).siblings(".visa-get__facts-item-answer").slideUp();
	$(this).toggleClass("active");
	$(this).siblings(".visa-get__facts-item-answer").slideToggle();
});


// Order share
$(".order-table__share-toggler").on("click", function () {
	$(".order-table__share-toggler").not(this).siblings(".order-table__share-list").removeClass("active");
	$(this).siblings(".order-table__share-list").toggleClass("active");
});

// Copy Order url
$(".order-table__share-btn--copy").on("click", function () {
	let url = $(this).attr('data-copy');
	navigator.clipboard.writeText(url);
	$(this).siblings(".order-table__share-copied").addClass("active");
	setTimeout(() => {
		$(this).siblings(".order-table__share-copied").removeClass("active");
	}, 2000);
});


document.addEventListener("DOMContentLoaded", () => {
	const tableContainer = document.querySelector('.order__table-container');
	const tooltips = document.querySelectorAll('.order-table__status-tooltip');

	if (!tableContainer || tooltips.length === 0) {
		console.log('Table container or tooltips not found.');
		return;
	}

	const adjustTooltips = () => {
		tooltips.forEach(tooltip => {
			// Сбрасываем предыдущий transform
			tooltip.style.transform = '';

			// Получаем координаты tooltip относительно таблицы
			const tableRect = tableContainer.getBoundingClientRect();
			const tooltipRect = tooltip.getBoundingClientRect();

			// Смещение tooltip относительно контейнера
			const offsetLeft = tooltipRect.left - tableRect.left;
			const offsetRight = tooltipRect.right - tableRect.right;

			// Если tooltip выходит за левую границу таблицы
			if (offsetLeft < 0) {
				tooltip.style.transform = `translateX(${Math.abs(offsetLeft)}px)`;
			}

			// Если tooltip выходит за правую границу таблицы
			if (offsetRight > 0) {
				tooltip.style.transform = `translateX(-${offsetRight}px)`;
			}
		});
	};

	// Выполняем проверку при загрузке
	adjustTooltips();

	// Добавляем обработчик на ресайз
	window.addEventListener('resize', adjustTooltips);
});


// Order table status
$(".mob .order-table__status-point").on("click", function () {
	$(".order-table__status-point").not(this).siblings(".order-table__status-tooltip").removeClass("active");
	$(this).siblings(".order-table__status-tooltip").toggleClass("active");
});


document.addEventListener("DOMContentLoaded", () => {

	$('.popup-auth-code__form').each(function () {
		const form = this;
		const inputs = form.querySelectorAll(".popup-auth-code__input");

		// Установить фокус на первое пустое поле
		const setFocusToFirstEmpty = () => {
			for (const input of inputs) {
				if (input.value === "") {
					input.focus();
					break;
				}
			}
		};

		// Обработчик ввода цифр
		inputs.forEach((input, index) => {
			input.addEventListener("input", (event) => {
				const value = event.target.value;

				// Ограничение ввода только одной цифры
				if (!/^[0-9]$/.test(value)) {
					input.value = "";
					return;
				}

				// Перемещаем фокус на следующее поле, если оно есть
				if (index < inputs.length - 1) {
					inputs[index + 1].focus();
				} else {
					// Если последнее поле заполнено, отправляем форму
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						$(form).trigger('submit');
					}
				}
			});

			// Обработчик клавиши Backspace
			input.addEventListener("keydown", (event) => {
				if (event.key === "Backspace") {
					if (input.value === "") {
						if (index > 0) {
							const previousInput = inputs[index - 1];
							previousInput.focus(); // Перемещаем фокус на предыдущее поле
							previousInput.value = ""; // Удаляем значение в предыдущем поле
						}
					} else {
						input.value = ""; // Очищаем текущее поле
					}
					event.preventDefault(); // Предотвращаем стандартное поведение
				}
			});

			// При фокусировании выделяем содержимое поля
			input.addEventListener("mousedown", (event) => {
				if (input.value !== "") {
					event.preventDefault(); // Предотвращаем снятие выделения
					input.select();
				}
			});

			input.addEventListener("focus", () => {
				if (input.value !== "") {
					input.select();
				} else {
					setFocusToFirstEmpty();
				}
			});
		});

		// Обработка вставки из буфера
		inputs.forEach((input) => {
			input.addEventListener("paste", (event) => {
				event.preventDefault();
				const pasteData = (event.clipboardData || window.clipboardData).getData("text");

				if (/^[0-9]+$/.test(pasteData)) {
					// Заполняем поля начиная с первого
					const digits = pasteData.split("");
					inputs.forEach((inp, idx) => {
						inp.value = digits[idx] || "";
					});

					// Устанавливаем фокус на первое пустое поле
					setFocusToFirstEmpty();

					// Если все поля заполнены, отправляем форму
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						$(form).trigger('submit');
					}
				}
			});
		});

	});

});


const pageLoader = document.querySelector('.page-loader');
const body = document.body;
const animItems = document.querySelectorAll('.anim-item');

// Если есть элемент loader
if (pageLoader) {
	body.classList.add('loading');
}

window.addEventListener('load', () => {
	if (pageLoader) {
		// Устанавливаем классы через таймауты
		setTimeout(() => {
			pageLoader.classList.add('ready');
			body.classList.remove('loading');
		}, 1000);
	}

	// Запускаем анимацию, если есть элементы для анимации
	if (animItems.length > 0) {
		setTimeout(() => {
			animOnScroll();

			// Добавляем обработчик скролла с использованием requestAnimationFrame для повышения производительности
			let animScrollTimeout;
			window.addEventListener('scroll', () => {
				if (!animScrollTimeout) {
					animScrollTimeout = requestAnimationFrame(() => {
						animOnScroll();
						animScrollTimeout = null;
					});
				}
			});
		}, 1400);
	}
});

// Оптимизированная функция анимации при скролле
function animOnScroll() {
	animItems.forEach((animItem) => {
		const animItemHeight = animItem.offsetHeight;
		const animItemOffsetTop = getOffset(animItem).top;
		const animStartOffset = 0.3;

		const triggerPoint = window.innerHeight * (1 - animStartOffset);
		const startVisible = window.scrollY > animItemOffsetTop - triggerPoint;
		const endVisible = window.scrollY < animItemOffsetTop + animItemHeight;

		if (startVisible && endVisible) {
			animItem.classList.add('animated');

			// Если элемент имеет класс .anim-item--counter
			if (animItem.classList.contains('anim-item--counter')) {
				// Запускаем счётчик для самого элемента, если у него есть data-counter-number
				if (animItem.hasAttribute('data-counter-number')) {
					startCounterAnimation(animItem);
				}

				// Запускаем счётчики для всех дочерних элементов с data-counter-number
				const childCounters = animItem.querySelectorAll('[data-counter-number]');
				childCounters.forEach((counter) => startCounterAnimation(counter));
			}
		} else if (!animItem.classList.contains('anim-item--no-hide')) {
			animItem.classList.remove('animated');
		}
	});
}

// Функция анимации счётчика
function startCounterAnimation(counterElement) {
	if (counterElement.dataset.animated) return; // Не запускать, если уже была анимация
	counterElement.dataset.animated = true;

	// Берём целевое значение из атрибута
	const targetNumber = parseInt(counterElement.dataset.counterNumber, 10) || 0;
	const duration = 1000; // Продолжительность анимации (в мс)
	const startTime = performance.now();

	function updateCounter(currentTime) {
		const elapsedTime = currentTime - startTime;
		const progress = Math.min(elapsedTime / duration, 1); // Ограничиваем до 1
		const currentNumber = Math.floor(progress * targetNumber);

		counterElement.textContent = currentNumber.toLocaleString(); // Форматируем число

		if (progress < 1) {
			requestAnimationFrame(updateCounter);
		} else {
			counterElement.textContent = targetNumber.toLocaleString(); // Устанавливаем конечное значение
		}
	}

	requestAnimationFrame(updateCounter);
}

// Функция для получения координат элемента
function getOffset(el) {
	const rect = el.getBoundingClientRect();
	return {
		top: rect.top + window.scrollY,
		left: rect.left + window.scrollX
	};
}


// Mice contacts
$(".contacts-element__toggler").on("click", function () {
	$(".contacts-element__toggler").not(this).siblings(".contacts-element__list").removeClass("active");
	$(this).siblings(".contacts-element__list").toggleClass("active");
});


const traffic = document.querySelector('.about-traffic');
if (traffic) {
	const bus = traffic.querySelector('.about-traffic__bus');

	const triggerAnimation = () => {
		if (!bus.classList.contains('animate')) {
			bus.classList.add('animate');
			bus.addEventListener('animationend', () => {
				bus.classList.remove('animate');
			}, { once: true });
		}
	};

	// Для десктопов
	traffic.addEventListener('mouseenter', triggerAnimation);

	// Для мобильных устройств
	traffic.addEventListener('touchstart', triggerAnimation);
}


// Получаем все кнопки с атрибутом data-hotel-tooltip-open
const hotelButtons = document.querySelectorAll('.about-hotel__button[data-hotel-tooltip-open]');
const tooltips = document.querySelectorAll('.about-hotels__tooltip');

// Функция для закрытия всех тултипов
const closeAllTooltips = () => {
	tooltips.forEach(tooltip => tooltip.classList.remove('active'));
};

// Навешиваем обработчик на каждую кнопку
hotelButtons.forEach(button => {
	button.addEventListener('click', (event) => {
		event.stopPropagation(); // Предотвращаем всплытие события
		const hotelName = button.getAttribute('data-hotel-tooltip-open');

		// Найти соответствующий тултип по атрибуту data-hotel-tooltip-name
		const targetTooltip = Array.from(tooltips).find(tooltip =>
			tooltip.getAttribute('data-hotel-tooltip-name') === hotelName
		);

		if (targetTooltip) {
			const isActive = targetTooltip.classList.contains('active');

			// Закрыть все тултипы
			closeAllTooltips();

			// Тоггл активного тултипа
			if (!isActive) {
				targetTooltip.classList.add('active');
			}
		}
	});
});

// Закрытие тултипа по клику на кнопку закрытия
tooltips.forEach(tooltip => {
	const closeButton = tooltip.querySelector('.about-hotels__tooltip-close');

	if (closeButton) {
		closeButton.addEventListener('click', (event) => {
			event.stopPropagation(); // Предотвращаем всплытие события
			tooltip.classList.remove('active');
		});
	}
});

// Закрытие тултипа при клике вне тултипа
document.addEventListener('click', () => {
	closeAllTooltips();
});

// Предотвращаем закрытие тултипа при клике внутри него
tooltips.forEach(tooltip => {
	tooltip.addEventListener('click', (event) => {
		event.stopPropagation();
	});
});


const aboutSafity = document.querySelector('.about-safity');
if (aboutSafity) {
	const video = aboutSafity.querySelector('.about-safity__video');

	const playVideo = () => {
		if (!video.classList.contains('active')) {
			video.classList.add('active');
			video.play();

			// Убираем класс после завершения видео
			video.addEventListener('ended', () => {
				video.classList.remove('active');
			}, { once: true });
		}
	};

	// Для десктопов
	aboutSafity.addEventListener('mouseenter', playVideo);

	// Для мобильных устройств
	aboutSafity.addEventListener('touchstart', playVideo, { passive: true });
}


document.addEventListener("DOMContentLoaded", function () {
	// Находим контейнер со всеми элементами
	const sliderContainer = document.querySelector(".places-slider__container");

	if (sliderContainer) {
		// Добавляем обработчик события клика на контейнер
		sliderContainer.addEventListener("click", function (event) {
			// Проверяем, что клик был по элементу с классом places-slider__item
			const clickedItem = event.target.closest(".places-slider__item");

			if (clickedItem && !clickedItem.classList.contains("active")) {
				// Найти текущий активный элемент
				const activeItem = sliderContainer.querySelector(".places-slider__item.active");

				// Получаем дополнительный класс у активного элемента (например, places-slider__item--1)
				const activeExtraClass = activeItem ? Array.from(activeItem.classList).find(cls =>
					cls.startsWith("places-slider__item--")
				) : null;

				// Получаем дополнительный класс у кликнутого элемента
				const clickedExtraClass = Array.from(clickedItem.classList).find(cls =>
					cls.startsWith("places-slider__item--")
				);

				// Если есть активный элемент, снимаем с него классы и ставим видео на паузу
				if (activeItem) {
					if (activeExtraClass) activeItem.classList.remove(activeExtraClass);
					activeItem.classList.remove("active");

					// Ставим видео на паузу, если оно есть
					const activeVideo = activeItem.querySelector("video");
					if (activeVideo) {
						activeVideo.pause();
					}
				}

				// Активируем новый элемент
				clickedItem.classList.add("active");

				// Меняем дополнительные классы
				if (clickedExtraClass && activeItem) activeItem.classList.add(clickedExtraClass);
				if (clickedExtraClass) clickedItem.classList.remove(clickedExtraClass);

				// Запускаем видео, если оно есть
				const clickedVideo = clickedItem.querySelector("video");
				if (clickedVideo) {
					clickedVideo.play();
				}
			}
		});
	}
});


document.addEventListener("DOMContentLoaded", () => {
	// Сохраняем ширину и высоту контента каждой колонки
	const getDimensions = () => {
		const dimensions = Array.from(document.querySelectorAll('.timing-schedule__month')).map((item) => {
			const content = item.querySelector('.timing-schedule__month-features');
			return {
				width: content.scrollWidth,
				height: content.scrollHeight
			};
		});

		// Получаем максимальную высоту
		const maxHeight = Math.max(...dimensions.map(dim => dim.height));

		// Устанавливаем значение максимальной высоты в CSS переменную
		document.documentElement.style.setProperty('--timing-schedule-month-max-height', `${maxHeight}px`);

		return dimensions.map(dim => dim.width); // Возвращаем только ширины
	};

	let widths = getDimensions();
	let isMobileView = window.innerWidth < 1024;

	const resetInlineStyles = () => {
		const items = document.querySelectorAll('.timing-schedule__month');
		items.forEach((item) => {
			const content = item.querySelector('.timing-schedule__month-features');
			item.style.flex = ''; // Сбрасываем flex стили
			item.classList.remove("active"); // Сбрасываем класс active
			content.style.display = ''; // Сбрасываем display стили
			item.onmouseenter = null; // Удаляем события для desktop
			item.onmouseleave = null;
			item.onclick = null; // Удаляем события для mobile
		});
	};

	const setEventListeners = () => {
		// Получаем все элементы заново
		const items = document.querySelectorAll('.timing-schedule__month');

		if (isMobileView) {
			// Логика для мобильных устройств
			items.forEach((item) => {
				const content = item.querySelector('.timing-schedule__month-features');

				// Сбрасываем начальное состояние
				item.classList.remove("active"); // Сбрасываем класс active
				content.style.display = 'none';

				// Добавляем обработчики для кликов
				item.onclick = () => {
					// Проверяем, открыт ли текущий элемент
					const isOpen = $(content).is(':visible');

					// Закрываем все элементы
					items.forEach((otherItem) => {
						const otherContent = otherItem.querySelector('.timing-schedule__month-features');
						$(otherContent).stop(true, true).slideUp();
						otherItem.classList.remove("active");
					});

					// Тогглим текущий элемент
					if (!isOpen) {
						item.classList.add("active");
						$(content).stop(true, true).slideDown();
					}
				};
			});
		} else {
			// Логика для десктопа
			items.forEach((item, index) => {
				const content = item.querySelector('.timing-schedule__month-features');
				item.onmouseenter = () => {
					item.style.flex = `0 0 ${widths[index] + 32}px`;
				};
				item.onmouseleave = () => {
					item.style.flex = '1 1 0px';
				};
			});
		}
	};

	// Устанавливаем слушатели при загрузке
	resetInlineStyles(); // Сбрасываем любые существующие стили
	setEventListeners();

	// Обновляем слушатели при ресайзе
	window.addEventListener('resize', () => {
		const newIsMobileView = window.innerWidth < 1024;
		if (newIsMobileView !== isMobileView) {
			isMobileView = newIsMobileView;
			resetInlineStyles(); // Сбрасываем все инлайновые стили и события
			widths = getDimensions(); // Обновляем ширины и высоты
			setEventListeners(); // Перепривязываем обработчики
		}
	});
});



// Получаем все элементы
const steps = document.querySelectorAll('.step-card');

if (steps.length) {
	const back = document.querySelector('.steps-nav__back');
	const backButton = document.querySelector('.steps-nav__btn-back');
	const nextButton = document.querySelector('.steps-nav__btn-next');
	const stepNavButtons = Array.from(document.querySelectorAll('.steps-nav__btn-to'));

	// Функция для обновления состояния кнопок
	function updateButtons(currentIndex) {
		// Обновляем кнопки "Назад" и "Дальше"
		if (currentIndex === 0) {
			back.classList.remove('active');
			backButton.classList.remove('active');
		} else {
			back.classList.add('active');
			backButton.classList.add('active');
		}

		if (currentIndex === steps.length - 1) {
			nextButton.classList.remove('active');
		} else {
			nextButton.classList.add('active');
		}

		// Обновляем состояние кнопок перехода по шагам
		stepNavButtons.forEach((button, index) => {
			if (index < currentIndex) {
				button.classList.add('active');
			} else {
				button.classList.remove('active');
			}
		});
	}

	// Функция для смены активного класса
	function setActiveStep(newIndex) {
		// Убираем active у всех шагов
		steps.forEach(step => step.classList.remove('active'));

		// Добавляем active нужному шагу
		steps[newIndex].classList.add('active');

		// Обновляем состояние кнопок
		updateButtons(newIndex);
	}

	// Определяем текущий активный шаг
	let currentIndex = 0;

	// Инициализируем начальное состояние кнопок
	updateButtons(currentIndex);

	// Обработчик для кнопки "Дальше"
	nextButton.addEventListener('click', () => {
		if (currentIndex < steps.length - 1) {
			currentIndex++;
			setActiveStep(currentIndex);
		}
	});

	// Обработчик для кнопки "Назад"
	backButton.addEventListener('click', () => {
		if (currentIndex > 0) {
			currentIndex--;
			setActiveStep(currentIndex);
		}
	});

	// Обработчики для кнопок перехода по шагам
	stepNavButtons.forEach((button, index) => {
		button.addEventListener('click', () => {
			if (index < steps.length) {
				currentIndex = index;
				setActiveStep(currentIndex);
			}
		});
	});
}


// if (steps.length) {
// 	const back = document.querySelector('.steps-nav__back');
// 	const backButton = document.querySelector('.steps-nav__btn-back');
// 	const nextButton = document.querySelector('.steps-nav__btn-next');

// 	// Функция для обновления состояния кнопок
// 	function updateButtons(currentIndex) {
// 		if (currentIndex === 0) {
// 			back.classList.remove('active');
// 			backButton.classList.remove('active');
// 		} else {
// 			back.classList.add('active');
// 			backButton.classList.add('active');
// 		}

// 		if (currentIndex === steps.length - 1) {
// 			nextButton.classList.remove('active');
// 		} else {
// 			nextButton.classList.add('active');
// 		}
// 	}

// 	// Функция для смены активного класса
// 	function setActiveStep(newIndex) {
// 		// Убираем active у всех
// 		steps.forEach(step => step.classList.remove('active'));

// 		// Добавляем active нужному элементу
// 		steps[newIndex].classList.add('active');

// 		// Обновляем состояние кнопок
// 		updateButtons(newIndex);
// 	}

// 	// Определяем текущий активный элемент
// 	let currentIndex = 0;

// 	// Инициализируем начальное состояние кнопок
// 	updateButtons(currentIndex);

// 	// Обработчик для кнопки "Дальше"
// 	nextButton.addEventListener('click', () => {
// 		if (currentIndex < steps.length - 1) {
// 			currentIndex++;
// 			setActiveStep(currentIndex);
// 		}
// 	});

// 	// Обработчик для кнопки "Назад"
// 	backButton.addEventListener('click', () => {
// 		if (currentIndex > 0) {
// 			currentIndex--;
// 			setActiveStep(currentIndex);
// 		}
// 	});
// }


const excursionsSlider = document.querySelector('.excursions__slider')
if (excursionsSlider) {
	let excursionsSwiper = new Swiper(".excursions__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 24
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 24
			},
			1224: {
				slidesPerView: 3,
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.excursions__slider-nav-btn--next',
			prevEl: '.excursions__slider-nav-btn--prev'
		}
	});

	$('.mice-excursion-card').each(function () {
		let miceExcursionCardThumbs = new Swiper($(this).find(".mice-excursion-card-thumbs")[0], {
			spaceBetween: 8,
			slidesPerView: 5,
			watchSlidesProgress: true,
			direction: "vertical",
			slidesPerView: 3,
		});
		let miceExcursionCardSlider = new Swiper($(this).find(".mice-excursion-card-slider")[0], {
			modules: [Thumbs, EffectFade],
			spaceBetween: 8,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			thumbs: {
				swiper: miceExcursionCardThumbs,
				autoScrollOffset: 1,
			},
		});
	});
};


const hotelsSlider = document.querySelector('.hotels__slider')
if (hotelsSlider) {
	let hotelsSwiper = new Swiper(".hotels__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 24
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 24
			},
			1224: {
				slidesPerView: 3,
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.hotels__slider-nav-btn--next',
			prevEl: '.hotels__slider-nav-btn--prev'
		}
	});
};


const eventsSlider = document.querySelector('.events__slider')
if (eventsSlider) {
	let eventsSwiper = new Swiper(".events__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 24
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 24
			},
			1224: {
				slidesPerView: 3,
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.events__slider-nav-btn--next',
			prevEl: '.events__slider-nav-btn--prev'
		}
	});
};


// Находим все кнопки .formats-des__item-btn и изображения .formats-des__media-image
const formatsButtons = document.querySelectorAll('.formats-des__item-btn');
const formatsImages = document.querySelectorAll('.formats-des__media-image');

// Добавляем обработчик клика для каждой кнопки
formatsButtons.forEach((button, index) => {
	button.addEventListener('click', () => {
		// Убираем класс active у всех кнопок и изображений
		formatsButtons.forEach(btn => btn.classList.remove('active'));
		formatsImages.forEach(img => img.classList.remove('active'));

		// Добавляем класс active текущей кнопке и соответствующему изображению
		button.classList.add('active');
		formatsImages[index].classList.add('active');
	});
});


const restaurantsSlider = document.querySelector('.restaurants__slider')
if (restaurantsSlider) {
	let restaurantsSwiper = new Swiper(".restaurants__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 24
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 24
			},
			1224: {
				slidesPerView: 3,
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.restaurants__slider-nav-btn--next',
			prevEl: '.restaurants__slider-nav-btn--prev'
		}
	});
};


const conferences = document.querySelector('.conferences')
if (conferences) {
	let conferencesSlider = new Swiper(".conferences-tab__slider", {
		modules: [Navigation, EffectFade],
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: '.conferences-tab__slider-nav-btn--next',
			prevEl: '.conferences-tab__slider-nav-btn--prev'
		}
	});
};


const clubsSlider = document.querySelector('.clubs__slider')
if (clubsSlider) {
	let clubsSwiper = new Swiper(".clubs__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		navigation: {
			nextEl: '.clubs__slider-nav-btn--next',
			prevEl: '.clubs__slider-nav-btn--prev'
		}
	});
};


const cruisesSlider = document.querySelector('.cruises__slider')
if (cruisesSlider) {
	let cruisesSwiper = new Swiper(".cruises__slider", {
		modules: [Navigation],
		slidesPerView: 1,
		navigation: {
			nextEl: '.cruises__slider-nav-btn--next',
			prevEl: '.cruises__slider-nav-btn--prev'
		}
	});
};



// Вызов функции при ресайзе окна
mice.applyEvents();
window.addEventListener('resize', function () {
	mice.applyEvents();
});



// Получаем элемент с временем
const clockElement = document.querySelector('.header__clock-time');

// Функция для обновления времени
function updateClock() {
	// Получаем текущее значение времени из элемента
	let timeText = clockElement.textContent.trim();
	let [hours, minutes] = timeText.split(':').map(Number);

	// Прибавляем минуту
	minutes++;
	if (minutes >= 60) {
		minutes = 0;
		hours++;
	}
	if (hours >= 24) {
		hours = 0;
	}

	// Форматируем часы и минуты с ведущими нулями
	const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
	clockElement.textContent = formattedTime;
}

// Запуск обновления времени каждую минуту
setInterval(updateClock, 60000);




// CRM Надо будет вынести в отдельный файл
// Document click
$(document).on("click", function (e) {
	// Main nav
	if ($(".order-guests-popup").hasClass("active")) {
		var callbackPopup = $(".order-card__guests-edit, .order-guests-popup");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".order-guests-popup").removeClass("active");
		};
	}
});


$(".order-card__guests-edit").on("click", function () {
	$(".order-guests-popup").toggleClass("active");
});


$(".popup-hotel__main").on("click", function () {
	$(this).closest(".popup-hotel").toggleClass("active");
});
